import React from 'react';

export enum Lang {
    Ru = 'ru',
    En = 'en',
}

/** @deprecated */
export default React.createContext<Lang>(Lang.Ru);
